// removed by extract-text-webpack-plugin
module.exports = {"popover":"Popover__popover___k_9WN","popper":"Popover__popper___2OUXl","light":"Popover__light___1Z1IJ","popper__arrow":"Popover__popper__arrow___-iIXj"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/packages/components/Overlay/Popover.scss
// module id = 559
// module chunks = 0